export default __webpack_public_path__ + "static/media/a037-student-t3-s3-3.0a8956c1.svg";